"use client";
import mixpanel from "mixpanel-browser";
import {IS_DEV} from "@/app/util/environment";

const MIXPANEL_TOKEN = IS_DEV
	? "1e283d07e000460bff6f1aa9a24de8a9"
	: "bc09bbd0948cece151490b637145edf2";
let initialized = false;

/** Once mixpanel.register()'d, these properties are passed to all events */
export const MIXPANEL_SUPER_PROPERTIES = {
	app: "academy2",
};

export const initMixpanel = (): boolean => {
	if (initialized) {
		return true;
	}

	if (MIXPANEL_TOKEN.length > 0) {
		mixpanel.init(MIXPANEL_TOKEN, {
			autocapture: {
				pageview: "full-url",
				click: false,
				input: false,
				scroll: false,
				submit: true,
				capture_text_content: false,
			},
		});
		mixpanel.register(MIXPANEL_SUPER_PROPERTIES);

		initialized = true;
		return true;
	}

	return false;
};
